<span class="block status-wrapper px-2 py-1 rounded-3xl w-fit m-auto {{renderFontFamily()}}"
      [ngClass]="{
    'status-default': statusStyle === 'default',
    'status-hold': statusStyle === 'hold',
    'status-primary': statusStyle === 'primary' || statusStyle === 'info',
    'status-new': statusStyle === 'new',
    'status-new-light': statusStyle === 'new-light',
    'status-purple': statusStyle === 'purple',
    'status-success': statusStyle === 'success',
    'status-awaiting': statusStyle === 'warn' || statusStyle === 'awaiting',
    'status-error': statusStyle === 'error',
    'status-cancelled': statusStyle === 'cancelled',
    'status-action': statusStyle === 'action',
    'status-action-light': statusStyle === 'action-light'}">
    {{ statusMessage }}
</span>
